import { Box } from "@mui/material";
import { motion } from "framer-motion";
import InfoBar from "../components/infoBar/InfoBar";
import MainNavbar from "../components/mainNavbar/MainNavbar";
import VideoHeader from "../components/videoHeader/VideoHeader";
import MultiTab from "../components/multiTab/MultiTab";

import Features from "../components/features/Features";
import ShippingInfo from "../components/shippingInfo/ShippingInfo";
import Partners from "../components/partners/Partners";
import LandingFooter from "../components/landingFooter/LandingFooter";
import RoadFeatures from "../components/roadFeatures/RoadFeatures";
import StoreLocator from "../components/storeLocator/StoreLocator";

const fadeInUp = {
  hidden: { opacity: 0, y: 60 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const LandingPage = () => {
  return (
    <Box sx={{ position: "relative", overflow: "hidden", minHeight: "100vh" }}>
      <header>
        <InfoBar />
        <Box sx={{ position: "relative", width: "100%" }}>
          <MainNavbar />
          <VideoHeader />
        </Box>
      </header>

      <main>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "2rem", md: "6rem" },
          }}
        >
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.05 }}
            variants={fadeInUp}
          >
            <MultiTab />
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeInUp}
          >
            <ShippingInfo />
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeInUp}
          >
            <Features />
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeInUp}
          >
            <RoadFeatures />
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeInUp}
          >
            <Partners />
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeInUp}
          >
            <StoreLocator />
          </motion.div>
        </Box>
      </main>

      <LandingFooter />
    </Box>
  );
};

export default LandingPage;
